import styled, { css } from 'styled-components';

import { SnackbarType } from '@/components/ui/Snackbar/Snackbar.types';
import { Typography } from '@/components/ui/Typography/Typography.styles';
import { BREAKPOINTS } from '@/constants/breakpoints';

export const SnackbarWrapper = styled.div<{
  $type: SnackbarType;
  $isOpen: boolean;
}>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: ${({ $type }) =>
    $type === 'error' ? 'var(--system-red)' : 'var(--system-green)'};
  padding: 15px 50px;
  z-index: 3;
  text-align: center;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding: 15px 20px;
  }

  ${({ $isOpen }) =>
    $isOpen
      ? css`
          visibility: visible;
          opacity: 1;
          transition:
            visibility 0s linear 0s,
            opacity 300ms;
        `
      : css`
          visibility: hidden;
          opacity: 0;
          transition:
            visibility 0s linear 300ms,
            opacity 300ms;
        `}
`;

export const Title = styled(Typography)`
  color: var(--bg-main);
`;
